"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PapermillView = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var React = _interopRequireWildcard(require("react"));

var PapermillView = function PapermillView(props) {
  if (!props.status) {
    return null;
  }

  if (props.status === "running") {
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "jsx-2667973196" + " " + "papermill"
    }, "Executing with Papermill..."), React.createElement(_style["default"], {
      styleId: "2667973196",
      css: ".papermill.jsx-2667973196{width:100%;background-color:#e8f2ff;padding-left:10px;padding-top:1em;padding-bottom:1em;padding-right:0;margin-right:0;box-sizing:border-box;}"
    }));
  }

  return null;
};

exports.PapermillView = PapermillView;